import type { OutilFpeDTO } from '@/features/api/extranet/dto/Demande/OUTILFPE'
import { PropertyStatus, type PropertyStatusConfiguration } from '@/features/domaine/property-status'
import type { ContextReglesOutilFpe } from './types'

export const propertyStatusConfiguration: PropertyStatusConfiguration<OutilFpeDTO, ContextReglesOutilFpe> = {
  sousDispositif: PropertyStatus.Required,
  lieuSignature: PropertyStatus.NotPresent,
  attestationPiecesJustificatives: PropertyStatus.Required,

  employeur: {
    contact: {
      email: PropertyStatus.Required,
    },
  },
  prestation: {
    etablissement: {
      $model: PropertyStatus.Required,
    },
    fraisAnnexes: {
      montant: (_value, _index, parent) => {
        return parent.nature === 'AchatMateriel' ? PropertyStatus.Required : PropertyStatus.Optional
      },
      quantite: (_value, _index, parent) => {
        return parent.nature === 'AchatMateriel' ? PropertyStatus.Required : PropertyStatus.Optional
      },
    },
  },
  attestationSurHonneur: PropertyStatus.Required,
  acceptationCg: PropertyStatus.Required,
} as const
